export enum MedicalCategory {
    InPatienFloor = 1,
    OutPatientClinic = 2,
    Emergency = 3,
    Laboratory = 4,
    Radiology = 5,
    OperatingTheater = 6,
    Pharmacy = 7
}